// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
export var isBaseClassifierNode = function isBaseClassifierNode(node) {
  return node.type === 'BaseClassifierNode';
};